module.exports = __webpack_public_path__ + "static/media/logo.fb0089ae.png";